import {CanActivateChildFn, CanActivateFn, Router} from '@angular/router';
import {PrlAuthenticationService} from './prl-authentication.service';
import {inject} from '@angular/core';

export const prlAuthentificationGuard: CanActivateFn & CanActivateChildFn = (route, state) => {
    const authService = inject(PrlAuthenticationService);
    const router = inject(Router);

    if (authService.isForceResetRequired()) {
        if (state.url.startsWith('/force-reset-password')) {
            return true;
        }
        router.navigate(['/force-reset-password']);
        return false;
    }

    if (authService.token && state.url !== '/terms' && !JSON.parse(localStorage.getItem('isTcAccepted'))) {
        router.navigate(['/terms']);
        return false;
    }

    if (!authService.loggedInUser() && !authService.token && state.url === '/terms') {
        return true;
    }

    if (!authService.loggedInUser()) {
        return authService.checkAuth();
    }

    return true;
}